import type { FC } from "react";
import { useDocumentsFeatureOptional } from "web_myplann/Api/Rights/RightsProvider";
import { PaperworkPage } from "web_myplann/Profile/Pages/PaperworkPage";
import { PaperworkV2Page } from "web_myplann/Profile/Pages/PaperworkV2Page";

export const PaperworkPageSwitch: FC = () => {
	const hasDocumentsFeature = useDocumentsFeatureOptional();

	return hasDocumentsFeature ? <PaperworkV2Page /> : <PaperworkPage />;
};
